export const VEHICLE_MISMATCH_ICON = {
  src: 'https://acko-cms.ackoassets.com/Alert_attention_caution_2_ada7fafd4c.svg',
  alt: 'Alert icon',
}
